<template>
    <div class="varFilterWrapper">
        <b-button class="filterButton shadow-none" v-bind:class="{ filterActive: isFilterActive }" block v-b-toggle="filterDef.extName">{{filterDef.title}}</b-button>
        <b-collapse :id="filterDef.extName">
            <b-card class="optionsCard">
                <b-form-checkbox-group class="checkboxGroup" stacked v-model="selected" :options="options" name="flavour-1a" @change="onChange"></b-form-checkbox-group>
            </b-card>
        </b-collapse>
    </div>
</template>z

<script>
    import {mapGetters} from "vuex";

    export default {
        name: 'VariableFilter',

        props: {
            filterDef: Object
        },

        data() {
            return {
                selected: [],
            }
        },

        computed: {
            ...mapGetters(['pages', 'completePath', 'getFilterDef']),

            options() {
                return this.filterDef.options.map(o => ({ text: o.title, value: o }) )
            },

            isFilterActive() {
                return this.selected.length>0
            }

        },

        methods: {
            onChange(checked) {
                this.$store.commit('setFilterOptions', { filterDef: this.filterDef, filterOptions: checked } )
            }
        }

    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .varFilterWrapper {
        margin-bottom: 1em;
    }

    button.filterButton {
        max-width: 285px;
        text-align: left;
    }

    .filterActive {
        color: red !important;
    }

    .checkboxGroup {
        overflow-x: hidden;
    }

    .optionsCard {
        max-width: 285px;
        background-color: #2c3e50;
    }
</style>
